<template>
    <b-container v-if="this.focusedVlinderData.length <= 1 || this.selectedStations <= 1"
                 style="width: 100%; height: 100%">
        <b-col :id="id" style="height: 100%"/>
        <!--        <b-col v-bind:cols="2" id="d3-viz-line-legend" style="height: 100%"/>-->
    </b-container>
    <b-container v-else>
        <b-row :id="id" style="height: 90%; width: 100%"></b-row>
        <b-row id="d3-viz-area-legend" style="width: 100%; height: 10%; padding-left: 40px">
            <b-col v-for="(datadeel, index) in focusedVlinderData"
                   v-bind:key="stationNames[datadeel[0].id]"
                   style="padding-left: 10px">
                <b-row>
                    <b-col cols="1" class="rect">
                        <svg width="10" height="10">
                            <rect width="10" height="10"
                                  v-bind:style="{ 'fill': colors[index] }"/>
                        </svg>
                    </b-col>
                    <b-col style="width: fit-content; text-align: left">{{stationNames[datadeel[0].id]}}</b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import VisualizationMixin from "../mixins/VisualizationMixin";
    import ResizeObserver from 'resize-observer-polyfill';
    import * as d3 from 'd3'
    import {uuidv4, customFormat} from "../utils";

    export default {
        name: "LineChartVisualization",
        data: function () {
            return {
                id: "id" + uuidv4(),
                width: 0,
                height: 0,
                startDate: String,
                endDate: String,
                textSizeLegend: 12,
                titleSizeLegend: 16,
                posX: -1,
                posY: -1,
                paddingLegend: 5,
                stationNames: {}
            }
        },
        props: {

            "yAxisLabel": String,
            "xAxisUnit": String,
            "msgEmpty": String,
            "yAxisGetter": Function,
            "lineStrokeWidth": {
                type: Number,
                default: 1.5
            },
        },
        mixins: [
            VisualizationMixin
        ],
        watch: {
            focusedVlinderData() {
                this.update_data(this.focusedVlinderData);
            },
            stations() {
                this.$store.getters.stations.forEach(st => {
                    if (!this.stationNames[st.id]) this.stationNames[st.id] = st.name
                })
            }
        },
        mounted() {
            this.$store.getters.stations.forEach(st => {
                if (!this.stationNames[st.id]) this.stationNames[st.id] = st.name
            });
            this.div = d3.select("#" + this.id);
            let observer = new ResizeObserver(this.create_graph);
            observer.observe(this.div.node());

            this.create_graph();
        },
        methods: {
            create_graph() {
                let div = d3.select("#" + this.id);

                this.div.selectAll("*").remove();

                let divBox = this.div.node().getBoundingClientRect();
                this.width = Math.max(divBox.width, 100);
                this.height = Math.max(divBox.height, 100);

                this.svg = div.append("svg", 0)
                    .style("overflow", "visible")
                    .style("z-index", 2)
                    .attr("width", this.width)
                    .attr("height", this.height);

                // setup everything
                this.padding = {top: 20, left: 40, right: 20, bottom: 50};

                this.xScale = d3.scaleTime()
                    .range([this.padding.left + this.lineStrokeWidth / 2, this.width - this.padding.right]);

                this.yScale = d3.scaleLinear()
                    .range([this.height - this.padding.bottom, this.padding.top]);

                this.xAxis = d3.axisBottom()
                    .tickFormat(customFormat)
                    .scale(this.xScale);

                this.yAxis = d3.axisLeft()
                    .scale(this.yScale)
                    .ticks(10);

                this.line = d3
                    .line()
                    .x(d => this.xScale(new Date(d.time)))
                    .y(d => this.yScale(this.yAxisGetter(d)));


                this.zoom = d3.zoom()
                    .scaleExtent([1, Infinity])
                    .extent([[this.padding.left, this.padding.top], [this.width + this.padding.left - this.padding.right, this.height + this.padding.top - this.padding.bottom]])
                    .translateExtent([[this.padding.left, this.padding.top], [this.width + this.padding.left - this.padding.right, this.height + this.padding.top - this.padding.bottom]])
                    .on("zoom", this.updateZoom);

                this.clip = this.svg.append("defs").append("SVG:clipPath")
                    .attr("id", "clip" + this.id)
                    .append("rect")
                    .attr("width", this.width - this.padding.right - this.padding.left)
                    .attr("height", this.height - this.padding.bottom - this.padding.top)
                    .attr("x", this.padding.left)
                    .attr("y", this.padding.top);

                this.xAxisGroup = this.svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", `translate(0, ${this.height - this.padding.bottom})`)
                    .attr("stroke-width", 1);

                this.yAxisGroup = this.svg.append("g")
                    .attr("class", "y axis")
                    .attr("transform", `translate(${this.padding.left}, 0)`)
                    .attr("stroke-this.width", 1);

                this.svg.select(".y.axis")
                    .append("text")
                    .text(this.yAxisLabel + " (" + this.xAxisUnit + ")")
                    .style("text-anchor", "end")
                    .attr("dx", -this.padding.top)
                    .attr("dy", "1em")
                    .attr("transform", "rotate(-90)")
                    .attr("fill", "black");

                this.xAxisGroup.call(this.xAxis)
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", ".15em")
                    .attr("transform", "rotate(-45)");

                this.yAxisGroup.call(this.yAxis);
                this.pathGroup = this.svg.append("g");

                this.tooltip_dots = d3.select({});  // Avoid errors when not data is selectd
                this.tooltip_line = this.svg.append("line")
                    .attr("x1", 50)
                    .attr("x2", 50)
                    .attr("y1", this.padding.top)
                    .attr("y2", this.yScale(0)) //TODO: checken wat dit geeft voor negatieve waarden
                    .style("opacity", 0)
                    .style("pointer-events", "none")
                    .style("stroke", "gray");
                this.tooltip_box = this.svg
                    .append("g")
                    .style('display', 'none');
                this.tooltip_box.append("rect")
                    .attr("class", "legend-background")
                    .attr("fill", "#b3b3b3")
                    .attr("opacity", 0.6)
                    .attr("rx", '3')
                    .attr("ry", '3');

                this.tooltip_box.append("text").attr("class", "title");

                this.svg.append("rect")
                    .attr("width", this.width - this.padding.left - this.padding.right)
                    .attr("height", this.height - this.padding.top - this.padding.bottom)
                    .style("fill", "none")
                    .style("pointer-events", "all")
                    .attr('transform', 'translate(' + this.padding.left + ',' + this.padding.top + ')')
                    .call(this.zoom)
                    .on("mouseover", this.showToolTips)
                    .on("mouseout", this.hideToolTips)
                    .on("mousemove", this.updateHighlightedPosition);

                if (this.current_data !== undefined) {
                    this.update_data(this.current_data);
                }

            },
            update_data(data) {
                this.current_data = Array.from(data);
                let flattened_data = data.flat(1);

                // update scales
                let dates = flattened_data.map(x => new Date(x.time));
                this.startDate = new Date(Math.min.apply(null, dates));
                this.endDate = new Date(Math.max.apply(null, dates));

                this.xScale.domain([this.startDate, this.endDate]);
                let [min, max] = d3.extent(flattened_data, this.yAxisGetter);
                this.yScale.domain([min, min === max ? min + 1 : max]);

                this.xAxisGroup.call(this.xAxis)
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", ".15em")
                    .attr("transform", "rotate(-45)");

                this.yAxisGroup.call(this.yAxis);

                this.selected = this.pathGroup
                    .selectAll("path")
                    .data(data);

                let path_data = this.selected
                    .enter()
                    .append("path")
                    .merge(this.selected);

                this.paths = path_data
                    .attr("clip-path", "url(#clip" + this.id + ")")
                    .attr("stroke", (d, i) => this.colors[i])
                    .attr("fill", "white")
                    .attr("fill-opacity", 0)
                    .attr("stroke-width", this.lineStrokeWidth)
                    .attr("d", this.line);

                this.selected.exit().remove();

                // Add tooltip dots to graph
                this.tooltip_dots = this.svg
                    .selectAll(".tooltip-dots")
                    .data(data);
                this.tooltip_dots = this.tooltip_dots
                    .enter()
                    .append("circle")
                    .merge(this.tooltip_dots)
                    .attr("class", "tooltip-dots")
                    .attr("r", 3)
                    .attr("fill", (d, i) => this.colors[i])
                    .attr("stroke", "black")
                    .style("pointer-events", "none")
                    .style("display", "none");
                this.tooltip_dots.exit().remove();
                // Add tooltip legend entries
                var legend_entries = this.tooltip_box
                    .selectAll("g.entry")
                    .data(data);
                legend_entries.exit().remove();
                var new_entries = legend_entries
                    .enter()
                    .append("g")
                    .attr("class", "entry")
                    .attr("height", 20);
                new_entries.append("circle")
                    .attr("class", "color-dot")
                    .attr("r", 2);
                new_entries.append("text")
                    .attr("class", "y-value")
                    .attr("fill", "black");

                legend_entries.merge(new_entries)
                    .attr("transform", (d, i) => "translate(0, " + (i + 1) * 20 + ")");


                if (data && data.length > 0 && min === max) {
                    this.svg
                        .append("text")
                        .attr("class", "empty")
                        .attr("y", this.height / 2)
                        .text(this.msgEmpty)
                        .style("fill", "#95999c")
                        .style("font-size", "11px")
                        .attr("width", this.width)
                        .attr("x", this.width / 2)
                        .style("text-anchor", "middle");
                } else {
                    this.svg.selectAll("text.empty").remove();
                }
            },
            showToolTips() {
                if (this.current_data && this.current_data.length > 0 && this.current_data[0].length > 0) {
                    this.tooltip_dots.style("display", null);
                    this.tooltip_line.style("opacity", 1);
                    this.tooltip_box.style("display", null);
                }
            },
            hideToolTips() {
                if (this.current_data && this.current_data.length > 0 && this.current_data[0].length > 0) {
                    this.tooltip_dots.style("display", "none");
                    this.tooltip_line.style("opacity", 0);
                    this.tooltip_box.style("display", "none");
                    this.tooltip_box.raise();
                }
            },
            updateToolTips() {
                if (this.current_data && this.current_data.length > 0 && this.current_data[0].length > 0) {
                    // Update position of tooltip elements according to mouse position
                    let currentXScale = this.xAxis.scale(); // Get zoomed scale
                    let valueX = currentXScale.invert(this.posX);
                    let bisectTime = d3.bisector(function (d) {
                        return new Date(d.time);
                    }).left;
                    let i = bisectTime(this.current_data[0], valueX, 1);
                    let d0 = this.current_data[0][i - 1],
                        d1 = this.current_data[0][i];
                    let selectedIndex = (d1 !== undefined) &&
                    new Date(valueX) - new Date(d0.time) > new Date(d1.time) - new Date(valueX) ?
                        i : i - 1;

                    valueX = new Date(this.current_data[0][selectedIndex].time);
                    let toolTipX = currentXScale(valueX);
                    let valuesY = this.current_data.map(d => this.yAxisGetter(d[selectedIndex]));

                    // Update tooltip dots
                    let self = this;
                    this.tooltip_dots
                        .attr("transform", function (d, i) {
                            let toolTipY = self.yScale(valuesY[i]);
                            return "translate(" + toolTipX + ", " + toolTipY + ")";
                        });

                    // Update tooltip line
                    this.tooltip_line
                        .attr("x1", toolTipX)
                        .attr("x2", toolTipX);


                    this.tooltip_box
                        .selectAll("g.entry text.y-value")
                        .data(valuesY)
                        .attr("fill", "black")
                        .attr("dx", 2 * this.paddingLegend)
                        .style("font-size", this.textSizeLegend + "px")
                        .text(d => d + this.xAxisUnit);
                    this.tooltip_box
                        .selectAll("g.entry circle.color-dot")
                        .data(valuesY)
                        .attr("r", 2)
                        .attr("transform", "translate(" + (1 + this.paddingLegend) + ", " + (1 - this.paddingLegend) + ")")
                        .attr("fill", (d, i) => this.colors[i])
                        .attr("stroke", "black")
                    ;

                    // Update rectangle size
                    var textElements = this.tooltip_box
                        .selectAll("text.y-value");

                    var width_entries = d3.max(textElements.nodes(), y => y.getComputedTextLength()) + 3 * this.paddingLegend;
                    var width_title = this.tooltip_box.select("text.title").node().getComputedTextLength() + 2 * this.paddingLegend;
                    var width = Math.max(width_entries, width_title);

                    var height = (1 + textElements.nodes().length) * 20 + this.paddingLegend;

                    this.tooltip_box.select('rect')
                        .attr("y", -20)
                        .attr("x", 0)
                        .attr("height", height)
                        .attr("width", width);

                    // Update tooltip information box
                    let translate_x = this.posX + 5;
                    if (this.posX + 5 + width > this.width - this.padding.right) {
                        translate_x = this.posX - 5 - width;
                    }
                    this.tooltip_box.attr("transform", "translate(" + translate_x + ", " + (this.posY + 15) + ")");

                    this.tooltip_box.select("text.title")
                        .text(d3.timeFormat((this.endDate - this.startDate) < 93600000 ?
                            "%H:%M" : "%d/%m/%y %H:%M")(new Date(valueX)))
                        .style("font-size", this.titleSizeLegend + "px")
                        .attr("dx", this.paddingLegend)
                        .attr("dy", 0)
                    ;

                }
            },
            updateHighlightedPosition() {
                let BB = this.svg.node().getBoundingClientRect();
                this.posX = d3.event.clientX - BB.x;
                this.posY = d3.event.clientY - BB.y + 20;
                this.updateToolTips();
            },
            updateZoom() {
                if (this.current_data && this.current_data.length <= 0 || this.current_data[0].length <= 0) {
                    return
                }

                // recover the new scale
                let newX = d3.event.transform.rescaleX(this.xScale);

                this.xAxis.scale(newX);

                // update axes with these new boundaries
                this.xAxisGroup.call(this.xAxis)

                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", ".15em")
                    .attr("transform", "rotate(-45)");

                this.line = d3
                    .line()
                    .x(d => newX(new Date(d.time)))
                    .y(d => this.yScale(this.yAxisGetter(d)));
                this.paths.attr("d", this.line);
                this.updateToolTips();
            }
        }
    }
</script>

<style scoped>

</style>